import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../../components/Landing/Header/headerScc";
import { Footer } from "../../../components/Landing/Footer";

export const Asistencia = () => {

  const url = 'https://docs.google.com/forms/d/e/1FAIpQLSdQ-r6a5hZyGj37Gtgtpcf_uK_UCxyP4HDLxA1CPJzewBbxNg/viewform?embedded=true'

  return (
    <>
      <Header />
      <HeaderScc />
      <div className="container-fluid2">
        <div className="row">
          <br />
          <iframe
            src={url}
            title="Formulario"
            style={{ width: '100%', height: '900px' }}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};
